export default __webpack_public_path__ + "static/media/sun.a95ac4e8.svg";